import { render, staticRenderFns } from "./all-tags-modal.vue?vue&type=template&id=47edf48c&"
import script from "./all-tags-modal.vue?vue&type=script&lang=js&"
export * from "./all-tags-modal.vue?vue&type=script&lang=js&"
import style0 from "./all-tags-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports